import http from "./httpService";
import Cookies from 'universal-cookie';
import { apiUrl,staticToken } from ".././config.json";

const cookies = new Cookies();
export const localstore = () => {
  localStorage.setItem("CREATEDBY", getCookieData("UserId"));
  localStorage.setItem("UPDATEDBY", getCookieData("UserId"));
  localStorage.setItem("HotelId",getCookieData("HotelId") );
  localStorage.setItem("UserRole",getCookieData("UserRole"));
  localStorage.setItem("UserId",getCookieData("UserId"));
  localStorage.setItem("BARID", getCookieData("BARID"))
  localStorage.setItem("BranchId", getCookieData("BranchId"))
  localStorage.setItem("BranchName", getCookieData("BranchName"))
  localStorage.setItem("ShiftId", getCookieData("ShiftId"))



};


export const getLocalStorageValues = (key) => {
  return localStorage.getItem(key);
};




// Store single Cookie Values

export const storeCookieData = (key, value) => {
  if (value) cookies.set(key, value, { path: "/" });
};

// Get Single Cookie Data

export function getCookieData(key) {
  return cookies.get(key);
}

// Remove Single Cookie Data

export function removeCookieData(key) {
  return cookies.remove(key, { path: "/" });
}

//  Removing all Cookie Data

export async function ClearCookie() {
  const allCookie = cookies.getAll();
  if (allCookie) {
    for (let key in allCookie) {
      await cookies.remove(key, { path: "/" });
    }
  }
}


  export const getSavedUserDetails = (MobileNo) => {
    const apiEndPoint = `${apiUrl}/getConsumerCoreDetails?Mobile=${MobileNo}`;
    return http.get(`${apiEndPoint}`);
  };